import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { InventarioProdutoImport } from "src/app/inventario/models/inventario";
import { environment } from "src/environments/environment";
import { filtroDashboard } from "../dashboard/models/dashboard";
import { CheckProdutoImport, EventoProdutoImport, EventoProdutoImportacaoLog } from "../evento/models/evento";
import { Produto, ProdutoEstoque, ProdutoEventoFornecedor } from "./models/produto";

@Injectable({
  providedIn: 'root'
})

export class ProdutoService {

  private environmentUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.environmentUrl = environment.ApiCore + '/Produto';
  }

  getProdutosEstoque() {
    return this.httpClient.get<ProdutoEstoque[]>(this.environmentUrl+"/estoque");
  }

  getProduto(idProduto) {
    return this.httpClient.get<Produto>(this.environmentUrl+"/"+idProduto);
  }

  getProdutos() {
    return this.httpClient.get<Produto[]>(this.environmentUrl+"/web");
  }

  getProdutosMobile() {
    return this.httpClient.get<Produto[]>(this.environmentUrl+"/web?type=mobile");
  }


  getProdutoGruposDesconto(idGrupoDesconto) {
    return this.httpClient.get<Produto[]>(this.environmentUrl + `/grupodesconto/` + idGrupoDesconto);
  }

  updProdutoGrupoDesconto(selectedProduto: Produto[], idGrupoDesconto: number) {
    return this.httpClient.put(this.environmentUrl + "/GrupoDesconto/" + idGrupoDesconto, selectedProduto);
  }

  addProduto(produto: Produto) {
    return this.httpClient.post(this.environmentUrl, produto);
  }

  importProduto(produto: string){
    return this.httpClient.post(this.environmentUrl + "/Importar/" + produto,{});
  
  }

  updProduto(produto: Produto) {
    return this.httpClient.put(this.environmentUrl, produto);
  }

  getProdutosSemEventoFornecedor(idEventoFornecedor: number) {
    return this.httpClient.get<Produto[]>(this.environmentUrl + "/SemEventoFornecedor/" + idEventoFornecedor);
  }

  getProdutosEventoFornecedor(){
    return this.httpClient.get<ProdutoEventoFornecedor[]>(this.environmentUrl + "/EventoFornecedor/");
  }

  getProdutosDashboard(idEvento: string){
    return this.httpClient.get<filtroDashboard[]>(this.environmentUrl + "/FiltroDashboard/"+ idEvento);
  }

  existeProdutoNectar(codigoProduto: string){
    return this.httpClient.get(this.environmentUrl + "/existeProdutoNectar/" + codigoProduto);
  }
  checkProdutoNectar(listaProduto: EventoProdutoImport[]): Observable<EventoProdutoImport[]> {
    return this.httpClient.post<EventoProdutoImport[]>(this.environmentUrl + "/checkProdutoNectar/",listaProduto);
  }

  checkImportarProdutoNectar(idEvento: number, listaProduto: EventoProdutoImport[]): Observable<EventoProdutoImport[]> {
    return this.httpClient.post<EventoProdutoImport[]>(this.environmentUrl + "/importarProdutoNectar/"+idEvento,listaProduto);
  }

  getLogImportacaoProduto(): Observable<EventoProdutoImportacaoLog[]> {
    return this.httpClient.get<EventoProdutoImportacaoLog[]>(this.environmentUrl + "/importarProdutoLog/");
  } 

  checkProduto(listaProduto: InventarioProdutoImport[], idEtapa:number): Observable<InventarioProdutoImport[]> {
    return this.httpClient.post<InventarioProdutoImport[]>(this.environmentUrl + "/checkProduto/"+idEtapa,listaProduto);
  }
}

